import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { object, string } from 'yup';
import { Divider, Typography } from '@mui/material';
import { TAssetInvestmentDetailsSchema } from '@brickwise/asset-validation/dist/asset/investmentData';
import { DefaultTextField } from 'src/components/mui-overrides/Textfield';
import { TotalIssuePrice } from './TotalIssuePrice';
import { MinSubscriptionAmountSlider } from '../atomic-components/MinSubscriptionAmountSlider';
import { AssetTypeConditional } from 'src/components/user/AssetTypeConditional';
import { MaxSubscriptionAmountSlider } from '../atomic-components/MaxSubscriptionAmountSlider';

export const validationSchemaIssuePriceCalculaton = object({
  totalIssuePrice: string(),
  numberOfShares: string(),
});

interface Props {
  disabled: boolean;
}
export const IssuePriceCalculation: FC<Props> = ({ disabled }) => {
  const formik = useFormikContext<TAssetInvestmentDetailsSchema>();

  const { t } = useTranslation();

  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.investment.issuepricecalculation.title')}>
      <Typography variant="subtitle2">{t('dashboard.assets.addedit.investment.issuepricecalculation.descriptionheadline')}</Typography>
      <Typography variant="body1">{t('dashboard.assets.addedit.investment.issuepricecalculation.description')}</Typography>
      <Divider sx={{ margin: '20px 0' }} />
      <TotalIssuePrice disabled={disabled} />
      <DefaultTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.investment.issuepricecalculation.fields.numberofshares.label')}
        type="number"
        fieldName={'investmentDetails.totalBricks'}
        formik={formik}
        size="small"
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="subtitle2">{t('dashboard.assets.addedit.investment.issuepricecalculation.text.shareprice')}</Typography>
        <Typography variant="body1" data-cy="share-price">
          {formik.values.investmentDetails?.sharePrice?.toFixed(2)}
        </Typography>
      </div>
      <Divider sx={{ margin: '20px 0' }} />
      <Typography>{t('dashboard.assets.addedit.investment.issuepricecalculation.fields.minSubscriptionAmount.label')}</Typography>
      <MinSubscriptionAmountSlider disabled={disabled} />
      <AssetTypeConditional supported={['citizenParticipationLoan']}>
      <Typography>{t('dashboard.assets.addedit.investment.issuepricecalculation.fields.maxSubscriptionAmount.label')}</Typography>
        <MaxSubscriptionAmountSlider disabled={disabled} />
      </AssetTypeConditional>
    </LaunchpadCard>
  );
};
